import React from "react";
import { ChakraProps } from "@chakra-ui/system/dist/types/system.types";
import { Box, useColorModeValue } from "@chakra-ui/react";

import { useGetThemeColors } from "ChakraTheme";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends ChakraProps, IChildrenProp {}

const ContentArea = ({ children, ...props }: IProps) => {
  const colors = useGetThemeColors();
  const backgroundColor = useColorModeValue(colors.white, colors.gray[600]);

  return (
    <Box
      backgroundColor={backgroundColor}
      {...props}
    >
      {children}
    </Box>
  );
};

export { ContentArea };
